import { useUserStore } from '../../stores/userStore';
import ChallengeQuestions from './components/ChallengeQuestions';
import PersonalInfo from './components/PersonalInfo';
import ResetPassword from './components/ResetPassword';

const Profile = () => {
	const { user } = useUserStore();

	return (
		<div className="profile">
			<div className="page-wide">
				<div className="space-y-10 divide-y divide-gray-900/10">
					<PersonalInfo user={user} />
					<ResetPassword user={user} />
					<div className="grid grid-cols-1 pt-10 gap-x-8 gap-y-8 md:grid-cols-3">
						<div className="px-4 sm:px-0">
							<h2>Challenge Questions</h2>
							<p className="mt-1 text-sm leading-6 text-gray-600">
								Set your challenge questions to allow for account recovery in
								case you forget your password.
							</p>
						</div>
						<ChallengeQuestions user={user} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Profile;
